<div class="flex pt-2" appManageValidatorDisplay [control]="formControl">
  <cap-input
    [formControl]="formControl"
    [label]="props.label"
    [hasTooltip]="props.tooltip"
    [placeholder]="props.placeholder"
    type="email">
    <app-form-tooltip [text]="props.tooltip" class="tooltip-content"></app-form-tooltip>
  </cap-input>
</div>
